/* eslint-disable no-console */
/**
 * Capitalizes the first word, and transform others to lower case
 * @param {string} str
 * @returns {string}
 */
export const capitalizeOnlyFirstWord = (str) => {
  if (typeof str !== 'string') {
    console.error('"capitalizeOnlyFirst()" accepts only strings!');
    return '';
  }
  return str
    .replaceAll(/[A-Z]/g, (x) => x.toLowerCase())
    .replace(/^([a-z])/, (x) => x.toUpperCase());
};

/**
 * Capitalizes the first word and the rest are untouched
 * @param {string} str
 * @returns {string}
 */
export const capitalize = (str) => {
  if (typeof str !== 'string') {
    console.error('"capitalize()" accepts only strings!');
    return '';
  }
  return str.charAt(0).toUpperCase() + str.slice(1);
};

/**
 * Capitalizes every word in string
 * @param {string} str
 * @returns {string}
 */
export const toTitleCase = (str) => {
  if (typeof str !== 'string') {
    console.error('"toTitleCase()" accepts only strings!');
    return '';
  }
  return str.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.slice(1).toLowerCase());
};
